import {useFormik} from "formik";
import {Button, Input, Modal} from "antd";
import React, {useState} from "react";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {useApiUpdateStudentProfile} from "@/api/userAcademy";
import {ErrorMessageWidget, FormField} from "@/pages/student/profile/_section/changeLocationModal";

export default function ChangeEducationModal({user, onSubmit, onClose, openModal}) {
    const [loading, setLoading] = useState(false);

    const {mutate: updateProfile} = useApiUpdateStudentProfile();


    const formik = useFormik({
        initialValues: {
            education: user?.education,
            education2: user?.education2,
            educationcourse: user?.educationcourse,

        },
        validate: (values) => {
            const errors = {};
            // if (!values.firstname) errors.firstname = "نام الزامی است";
            // if (!values.lastname) errors.lastname = "نام خانوادگی الزامی است";
            // if (!values.father) errors.father = "نام پدر الزامی است";
            // if (!values.birthdate) errors.birthdate = "تاریخ تولد الزامی است";
            // if (!values.marital) errors.marital = "وضعیت تاهل الزامی است";

            return errors;
        },
        onSubmit: (values) => {

            setLoading(true);
            updateProfile(values, {
                onSuccess: (res) => {
                    onSubmit(res);
                    ApiHandleSuccessMessage(res);
                    setLoading(false);
                },
                onError: (errors) => {
                    ApiHandleErrorMessage(errors);
                    setLoading(false);
                },
            });
        },
    });


    return (
        <Modal
            title={"اطلاعات تحصیلی خود را با دقت وارد کنید"}
            open={openModal}
            onCancel={() => {
                onClose?.();
            }}
            footer={[
                <Button onClick={() => onClose?.()}>لغو</Button>,
                <Button
                    type="primary"
                    loading={loading}
                    disabled={loading}
                    onClick={() => formik.submitForm()}
                >
                    ذخیره
                </Button>,
            ]}
        >
            <div className="flex flex-col gap-3">

                <FormField label="تحصیلات" name="education">
                    <Input
                        name="education"
                        value={formik.values.education}
                        onChange={(e) => formik.setFieldValue('education', e.target.value)}
                    />
                    {formik.errors.education && <ErrorMessageWidget message={formik.errors.education}/>}
                </FormField>
                <FormField label="رشته تحصیلی" name="educationcourse">
                    <Input
                        name="educationcourse"
                        value={formik.values.educationcourse}
                        onChange={(e) => formik.setFieldValue('educationcourse', e.target.value)}
                    />
                    {formik.errors.educationcourse && <ErrorMessageWidget message={formik.errors.educationcourse}/>}
                </FormField>

                <FormField label="تحصیلات ثانوی" name="education2">
                    <Input
                        name="education2"
                        value={formik.values.education2}
                        onChange={(e) => formik.setFieldValue('education2', e.target.value)}
                    />
                    {formik.errors.education2 && <ErrorMessageWidget message={formik.errors.education2}/>}
                </FormField>

            </div>
        </Modal>
    );
}
